/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'

/**
 * Declare Variable
 */
const defaultIsSwitchBottomSheetState = false
const defaultIsActiveBottomSheetSubmitButtonState = false
const defaultIsNavBarSwiperExpandedState = false

/**
 * Export
 */
export const isSwitchBottomSheet = handleActions({
  SWITCH_BOTTOM_SHEET: (state, action) => {
    return action.payload
  },
}, defaultIsSwitchBottomSheetState)

export const isActiveBottomSheetSubmitButton = handleActions({
  ACTIVE_BOTTOM_SHEET_SUBMIT_BUTTON: (state, action) => {
    return action.payload
  },
}, defaultIsActiveBottomSheetSubmitButtonState)

export const isNavBarSwiperExpanded = handleActions({
  NAV_BAR_SWIPER_EXPANDED: (state, action) => {
    return action.payload
  },
}, defaultIsNavBarSwiperExpandedState)

export default {
  isSwitchBottomSheet,
  isActiveBottomSheetSubmitButton,
  isNavBarSwiperExpanded,
}



// WEBPACK FOOTER //
// ./src/reducers/components/stepper.js